import React from 'react';
import imran from './assets/img/imran.png';
import Typed from 'react-typed'

const Home = () => {
  return (
    <>
    <div className='bg-indigo-700 p-4 grid md:grid-cols-2  ' >
      <div className='mx-2  py-3  cols-span-1'>
        <h1 className='text-3xl my-5 text-white font-serif font-bold undeline underline-offset-8 hover:text-yellow-600 '>Portlio</h1>
        <h1 className='text-2xl font-sans text-white '>Muhammad <span className='text-orange-400'>Imran</span></h1>
        <h1 className='text-lg md:text-3xl text-pink-50 my-5 '><span className='3xl text-yellow-400'>Skills </span> 

                <Typed
                className='pl-3 text-lg md:text-3xl  '
                strings={[
                     
                    'React js',
                    'React BootStrap',
                    'React Router',
                    'TailwindCss']}
                    typeSpeed={30}
                    backSpeed={40}
                    loop={Infinity}
                 >
                   
                </Typed></h1>
      </div>
      <div className='mx-5  py-3  ml-4 cols-span-1 w-[80%]'>
        <img src={imran} alt="" srcset="" />
      </div>
      
    </div>
    <div className='bg-sky-500 mt-[10px] py-6  grid grid-cols-1 md:grid-cols-2 '>
    <div className='mx-2  border-black py-8'>
        <h1 className='text-3xl py-3 text-yellow-700 font-mono my-2'>Personal Info</h1>
                  <h3 className='py-3 text-white text-3xl'>Graduation In Computer Science
                  <span className='text-yellow-600 text-3xl'>University Of Buner</span></h3>
                  <h2 className='text-3xl text-white py-5'>Working On</h2>
                  <p className='py-5 text-white text-2xl font-serif capitalize'>I have working on HTML5 CSS3 And Js ES6 And Close To my heart 
                  Fronted Javascript library reactjs
                  </p>
    </div>
    <div className='mx-2  py-8'>
        <h1 className='text-3xl py-3 text-yellow-700 font-mono my-2'>Futur setup</h1>
               <ul>
                <li className='list-none text-2xl ml-[20px] placeholder-purple-600'>reactjs</li>
                <li className='list-none text-2xl ml-[20px] placeholder-purple-600'>react router</li>
                <li className='list-none text-2xl ml-[20px] placeholder-purple-600'>reat Ui</li>
               </ul>
                 
    </div>

    </div>
    </>

  )
}

export default Home;